/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MediaBlogPostResponse } from '../../models/media-blog-post-response';

export interface GetMediaBlogPost$Params {
  slug: string;
}

export function getMediaBlogPost(http: HttpClient, rootUrl: string, params: GetMediaBlogPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MediaBlogPostResponse>> {
  const rb = new RequestBuilder(rootUrl, getMediaBlogPost.PATH, 'get');
  if (params) {
    rb.path('slug', params.slug, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MediaBlogPostResponse>;
    })
  );
}

getMediaBlogPost.PATH = '/rest/media/blog-post/{slug}';
